import { render, staticRenderFns } from "./NotLogged.vue?vue&type=template&id=60ec1540&scoped=true&"
import script from "./NotLogged.vue?vue&type=script&lang=js&"
export * from "./NotLogged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec1540",
  null
  
)

export default component.exports